import { Header, LoadingSpinner } from '@components/Generic'
import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { DefaultScenario } from '@components/AddressUploadIkano/DefaultScenario'
import { ResidenceProofRetryScenario } from '@components/AddressUploadIkano/ResidenceProofRetryScenario'
import { IdCardRetryScenario } from '@components/AddressUploadIkano/IdCardRetryScenario'

export const AddressUploadIkanoPage = observer(() => {
  const store = useContext(StoreContext)

  const { context } = store.ScenarioState
  const { pixelSpeak: trans } = store.TranslationsState.translationsNew

  const [loading, setLoading] = useState(false)

  const renderUploadComponent = () => {
    if (context?.isRetryAttempt && context?.previousAttempt?.documentType === 'ResidenceProof') {
      return <ResidenceProofRetryScenario setLoading={setLoading} />
    } else if (context?.isRetryAttempt && context?.previousAttempt?.documentType === 'IdCard') {
      return <IdCardRetryScenario setLoading={setLoading} />
    }

    return <DefaultScenario setLoading={setLoading} />
  }

  return (
    <div className="page-container">
      {loading ? (
        <>
          <Header>{trans.verifying}</Header>
          <LoadingSpinner />
        </>
      ) : (
        <>{renderUploadComponent()}</>
      )}
    </div>
  )
})
